// extracted by mini-css-extract-plugin
module.exports = {"root":"Consent_root__3vwbz","content":"Consent_content__1U_GC","footer":"Consent_footer__jZz08"};